export default __webpack_public_path__ + "static/person-138f79cbd6c306a9d029718817d0d1be.jpg";